import React from 'react';

const MMF = () => {
  return (
    <div>
      <h1>MMF Page</h1>
      <p>This is a placeholder page for MMF.</p>
    </div>
  );
};

export default MMF;
